import { useFinanceiroFichaViewer } from "./use-financeiro-ficha-viewer";
import { FinanceiroFichaViewerView } from "./view-financeiro-ficha-viewer";
import type { FinanceiroFichaViewerProps } from "./types-financeiro-ficha-viewer";

export function FinanceiroFichaViewer(props: FinanceiroFichaViewerProps) {
  const vm = useFinanceiroFichaViewer(props);

  return <FinanceiroFichaViewerView {...vm} />;
}

export type * from "./types-financeiro-ficha-viewer";
